import React from 'react';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../../Selects/SelectComponent';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';

// import { Container } from './styles';

function AcessoriosExtra({acessoriosExtra, editarProposta, linhaP, handleChildChange1 = () => {}, ivas, aluguer}) {
    const {t} = useTranslation();

    function calculoTotalLinha() {
        var total = Number(acessoriosExtra?.preco) * Number(acessoriosExtra?.quantidade);
        var TotalCdesconto = total - total * Number(acessoriosExtra?.desconto == null ? 0 : acessoriosExtra?.desconto / 100);
        if (TotalCdesconto.toString() == 'NaN') {
            TotalCdesconto = 0;
        }
        return TotalCdesconto?.toFixed(2);
    }

    return (
        <tr className="bg-gray-100 border-b border-white dark:bg-gray-600 dark:border-gray-700 ">
            <td className="text-right"></td>
            <td className="text-right"></td>
            <td className="text-left ">
                <button
                    title={t('acessoriosExtra')}
                    type="button"
                    className="relative inline-flex items-center font-bold p-1 text-xs  text-center cursor-pointer rounded-[5px] bg-blue-200 dark:bg-blue-400  text-blue-600 hover:text-blue-800 dark:text-blue-800 dark:hover:text-blue-600 ">
                    EX
                </button>
            </td>
            <td className="px-6 "></td>
            <td className="px-6 ">{acessoriosExtra?.descricao}</td>
            <td className="px-6 ">{acessoriosExtra?.stock}</td>
            <td className="px-6 ">{acessoriosExtra?.encFornc}</td>
            {!aluguer && (
                <td className="px-6 py-1">
                    <input
                        type="number"
                        placeholder="0"
                        value={acessoriosExtra?.ecoValor || ""}
                        className="block w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                        onChange={e => {
                            if (Number(e.target.value) < 0) acessoriosExtra.ecoValor = 0;
                            else acessoriosExtra.ecoValor = Number(e.target.value);
                            handleChildChange1(acessoriosExtra);
                        }}
                        disabled={!editarProposta}
                    />
                </td>
            )}
            {/* {!aluguer && (
                <td className="px-6 py-1">
                    <div className="flex flex-row items-center">
                       
                        <input
                            disabled={!editarProposta}
                            type="number"
                            min={0}
                            max={100}
                            placeholder="0"
                            value={acessoriosExtra?.iva || ""}
                            className="block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                            onChange={e => {
                                if (Number(e.target.value) > 100) acessoriosExtra.iva = 100;
                                else if (Number(e.target.value) < 0) acessoriosExtra.iva = 0;
                                else acessoriosExtra.iva = Number(e.target.value);
                                handleChildChange1(acessoriosExtra);
                            }}
                        />
                        {acessoriosExtra.validacaoIVA ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
                    </div>
                </td>
            )} */}

            <td className="px-6 py-1">
                <input
                    type="number"
                    min={0}
                    placeholder="0"
                    value={acessoriosExtra?.quantidade || ""}
                    className="block w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                    onChange={e => {
                        if (Number(e.target.value) < 0) acessoriosExtra.quantidade = 0;
                        else acessoriosExtra.quantidade = Number(e.target.value);
                        handleChildChange1(acessoriosExtra);
                    }}
                    disabled={!editarProposta}
                />
            </td>
            {!aluguer && (
                <td className="px-6 py-1">
                    <input
                        type="number"
                        min={0}
                        placeholder="0"
                        value={acessoriosExtra?.preco || ""}
                        className="block w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                        onChange={e => {
                            if (Number(e.target.value) < 0) acessoriosExtra.preco = 0;
                            else acessoriosExtra.preco = Number(e.target.value);
                            handleChildChange1(acessoriosExtra);
                        }}
                        disabled={!editarProposta}
                    />
                </td>
            )}
            {!aluguer && (
                <td className="px-6 py-1">
                    <input
                        type="number"
                        max={100}
                        min={0}
                        placeholder="0"
                        value={acessoriosExtra?.desconto || ""}
                        className="block w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700"
                        onChange={e => {
                            if (Number(e.target.value) > 100) acessoriosExtra.desconto = 100;
                            else if (Number(e.target.value) < 0) acessoriosExtra.desconto = 0;
                            else acessoriosExtra.desconto = Number(e.target.value);
                            handleChildChange1(acessoriosExtra);
                        }}
                        disabled={!editarProposta}
                    />
                </td>
            )}
            {!aluguer && (
                <td className="px-6 py-1">
                    <input
                        type="number"
                        defaultValue={acessoriosExtra?.total}
                        className="block font-bold text-right dark:text-white w-full text-xs mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 bg-gray-200 border-gray-100 rounded-[5px] shadow-sm dark:bg-gray-700 dark:border-gray-700"
                        disabled
                        value={calculoTotalLinha()}
                    />
                </td>
            )}
            {!aluguer && <td className="px-6 py-1"></td>}
            <td className="px-6 "></td>
        </tr>
    );
}

export default AcessoriosExtra;
